<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

        <HomeComponent/>

    </transition>
  </div>
</template>

<script>

import HomeComponent from '@/components/HomeComponent.vue'

export default {
  name: 'Home',
  components: {
    HomeComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
